import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Pricing from './components/Pricing';
import Chatbot from './components/Chatbot';
import InterviewConfig from './components/InterviewConfig';
import Interview from './components/Interview';
import Login from './components/login.js';
import Password from './components/changepassword.js'
import Profile from './components/subscription.js'
import Signup from './components/Signup.js';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentCancelled from './components/PaymentCancelled';
import HomeloggedIn from './components/homeloggedIn.js';
import Contact from './components/contactus.js';
import Feedback from './components/feedback.js';
import BlogPage from './pages/blog/page';



import VerifyEmail from './components/verifyemail';
// import RefrshHandler from './RefrshHandler';
import { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [isAuthenticated, setIsAuthenticated]= useState(false);
  return (
    <Router>
      <div className="App">
        <ToastContainer 
        position="top-right" 
        autoClose={5000} 
        limit={3} 
      />
      {/* <RefrshHandler setIsAuthenticated={setIsAuthenticated} /> */}
        <Navbar />
        <div className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/chatbot" element={<Chatbot />} />
            <Route path="/interview-config" element={<InterviewConfig />} />
            <Route path="/interview/:id" element={<Interview />} />
            <Route path="/login" element={<Login/>} />
            <Route path="/subscription" element={<Profile/>} />
            <Route path="/changepassword" element={<Password/>} />
            <Route path='/signup' element={<Signup />} />
            <Route path='/verify-email' element={<VerifyEmail />}></Route>
            <Route path='/loggedInUser' element={<HomeloggedIn />} /> 
            <Route path='/contactus' element={<Contact />} /> 
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-cancelled" element={<PaymentCancelled />} />
            <Route path='/feedback' element={<Feedback />} /> 
            {/* Redirect old paths to new ones */}
            <Route path="/ai-assistant" element={<Navigate to="/interview-config" replace />} />
            <Route path="/blog" element={<BlogPage />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App; 
